import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import StudentGradedQuizSubmissionsTable from '@/tables/StudentGradedQuizSubmissionsTable';
import StudentQuizSubmissionsTable from '@/tables/StudentQuizSubmissionsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes/',
)({
  component: QuizzesScreen,
});

function QuizzesScreen() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const studentId = Number.parseInt(memberId, 10);

  return (
    <Container>
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('wbs.pending-submissions')} />
      </GroupHeaderWrapper>
      <StudentQuizSubmissionsTable studentId={studentId} />
      <div style={{ paddingTop: '134px' }}>
        <GroupHeaderWrapper>
          {/* The catalogue source carries the colon — `All Graded Submissions:`
              — so the heading needs no trailing space grafted onto it. */}
          <TitleWithQuestion title={t('lessons.all-graded-submissions')} />
        </GroupHeaderWrapper>
      </div>
      <StudentGradedQuizSubmissionsTable studentId={studentId} />
    </Container>
  );
}

const Container = styled.div`
  padding-bottom: 50px;
`;
